import { render, staticRenderFns } from "./listarItemsInventario.vue?vue&type=template&id=2370dec6&scoped=true&"
import script from "./listarItemsInventario.vue?vue&type=script&lang=js&"
export * from "./listarItemsInventario.vue?vue&type=script&lang=js&"
import style0 from "./listarItemsInventario.vue?vue&type=style&index=0&id=2370dec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2370dec6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VIcon,VImg,VList,VListItem,VListItemContent,VListItemTitle,VRow,VSubheader})
